/* eslint-disable no-undefined */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import GroupIcon from '@material-ui/icons/GroupWork';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { LIGHTBLUE, LIGHTGREY, DEEPORANGE } from '../../utils/color_utils';
import firebase from '../../store/firebase';
import Badge from '@material-ui/core/Badge';
import { SET_SEEN_GROUP_NOTIFICATIONS, SHOW_TOAST } from '../../store/actions/types';
import { fetchUserData } from '../../store/actions/userActions';
import { showToast } from '../../store/actions/toastAction';
import Modal from 'react-modal';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  groupslabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: LIGHTBLUE,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    borderBottom: `1px solid ${LIGHTGREY}`,
    padding: theme.spacing(),
    fontSize: '0.8rem',
    lineHeight: 1.2,
    zIndex: 2,
  },
  groupIcon: {
    fontSize: '1.2rem',
    color: LIGHTBLUE,
    marginRight: theme.spacing(0.5),
  },
  groupText: {
    fontSize: '0.8rem',
    lineHeight: 2.2,
    display: 'inline-block',
  },
  badge: {
    backgroundColor: DEEPORANGE,
    padding: 0,
    borderRadius: 4,
    color: '#fff',
    marginLeft: '8px',
    fontSize: '0.5rem',
  },
  listItem: {
    padding: '2px 8px',
    backgroundColor: '#fff',
    fontSize: '0.585rem',
    '&:hover': {
      backgroundColor: '#eee',
    },
  },
  list: {
    maxHeight: '200px',
    minHeight: '100px',
    overflowY: 'auto !important',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
});

class GroupsListAll extends Component {
  state = {
    groups: [],
    initPosts: false,
    modalIsOpen: false,
    selectedGroup: '',
    modalMessage: '',
    modalTitle: '',
    gtype: 0,
  };

  async componentDidMount() {
    let database = firebase.database;
    let ref = 'company_groups/' + this.props.userdata.companyID;

    try {
      
      
      const snapshot = await database.ref(ref).once('value');
      
      const groupsArr = [];
      const promises = [];

      snapshot.forEach(childSnapshot => {
        
        if (childSnapshot.val().active === true || childSnapshot.val().active === undefined) {
          
          promises.push(
            (async () => {
              const inGroup = await this.userInGroup(
                this.props.userdata.userID,
                childSnapshot.val().group_id,
                this.props.userdata.companyID
              );
              
              if (inGroup !== 2) {
                
                groupsArr.push({
                  id: childSnapshot.key,
                  group_id: childSnapshot.val().group_id,
                  group_name: childSnapshot.val().group_name,
                  group_details: childSnapshot.val(),
                });
              }
            })()
          );
        }
      });

      await Promise.all(promises);
      
      this.setState({ groups: groupsArr });
    } catch (error) {
      
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.initPosts === false) {
      if (this.state.groups.length > 0) {
        this.props.fetchUserData({
          type: SET_SEEN_GROUP_NOTIFICATIONS,
          userID: this.props.userdata.userID,
          groupid: this.state.groups[0].group_id,
          unseengroupnotifications: this.props.unseengroupnotifications.unseengroupnotifications,
        });
      }
      this.setState({ initPosts: true });
    }
    if (!this.props.inGroup && prevProps.inGroup !== this.props.inGroup && !this.state.modalIsOpen) {
      this.setState({ modalIsOpen: true });
    }
  }

  async userInGroup(userID, groupID, companyID) {
    
    try {
      const database = firebase.database;
      const snapshot = await database
        .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
        .once('value');

      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        return userData.active ? 2 : 1;
      } else {
        return 3;
      }
    } catch (error) {
      
      return 3;
    }
  }

  addUserToGroup = async (companyID, groupID, userID, userEmail, firstName, lastName) => {
    try {
      const userData = {
        can_add_remove_users: false,
        can_edit: false,
        can_post: false,
        company_ID: companyID,
        company_name: 'MeVision',
        email: userEmail,
        firstName: firstName,
        lastName: lastName,
        userID: userID,
        active: false,
        admin: false,
      };
      await firebase.database
        .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
        .set(userData);

      this.setState({ modalIsOpen: false });

      let params = {
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'We sent a request for you to be added to the group.',
      };

      this.props.showToast(params);
    } catch (error) {
      
    }
  };

  handleJoin = () => {
    try {
      const { companyID, userID, userEmail, firstName, lastName } = this.props;
      const { selectedGroup } = this.state;
      

      this.addUserToGroup(companyID, selectedGroup, userID, userEmail, firstName, lastName);
    } catch (error) {
      
    }
  };

  handleClose = () => {
    this.setState({ modalIsOpen: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  selectedList = async (id, item) => {
    
    

    const companyID = this.props.userdata.companyID;
    const groupID = item.group_id;
    const groupName = item.group_name;
    const userID = this.props.userdata.userID;
    
    

    const inGroup = await this.userInGroup(userID, groupID, companyID);

    switch (inGroup) {
      case 1:
        this.setState({
          modalTitle: groupName,
          modalMessage: `The ${groupName} administrator still has to activate you. Thank you for your patience.`,
          modalIsOpen: true,
          selectedGroup: groupID,
          gtype: 1,
        });
        break;
      case 2:
        break;
      case 3:
        this.setState({
          modalTitle: 'Join Group',
          modalMessage: `Would you like to join ${groupName}?`,
          modalIsOpen: true,
          selectedGroup: groupID,
          gtype: 3,
        });
        break;
      default:
        this.setState({
          modalTitle: groupName,
          modalMessage: 'Would you like to join this group?',
          modalIsOpen: true,
          selectedGroup: groupID,
          gtype: 3,
        });
        break;
    }
  };

  render() {
    const { classes, unseengroupnotifications } = this.props;
    const { modalIsOpen, modalMessage, modalTitle, gtype } = this.state;

    return (
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <div className={classes.root}>
          <Typography
            className={classes.groupslabel}
            variant="subtitle2"
            gutterBottom
          >
            <GroupIcon className={classes.groupIcon} /> All Groups
          </Typography>
          <List component="nav" aria-label="Secondary mailbox folders" className={classes.list}>
            {this.state.groups
              ? this.state.groups.map(item => (
                  <ListItem
                    button
                    divider={true}
                    key={item.id}
                    onClick={this.selectedList.bind(this, item.id, item.group_details)}
                    className={classes.listItem}
                  >
                    <ListItemText
                      primary={
                        <Typography className={classes.groupText} component="strong">
                          {item.group_name}
                          <Badge
                            invisible={unseengroupnotifications[item.group_id] ? false : true}
                            badgeContent={
                              <span className={classes.badge}>
                                {unseengroupnotifications[item.group_id]}
                              </span>
                            }
                          />
                        </Typography>
                      }
                    />
                  </ListItem>
                ))
              : <div style={{ textAlign: 'center', padding: '50px 20px 20px' }}>
                  No groups available
                </div>}
          </List>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.handleClose}
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '400px',
              width: '100%',
              zIndex: 1000,
            },
            overlay: {
              zIndex: 999,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          }}
          contentLabel="Join Group Modal"
          appElement={document.getElementById('root')}
        >
          {gtype === 2 ? (
            <div>something</div>
          ) : (
            <>
              <h2>{modalTitle}</h2>
              <p>{modalMessage}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                {gtype === 3 ? (
                  <button
                    onClick={this.handleJoin}
                    style={{
                      padding: '10px 20px',
                      border: '1px solid #007bff',
                      borderRadius: '4px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      cursor: 'pointer',
                      outline: 'none',
                      transition: 'background-color 0.2s',
                    }}
                  >
                    Yes
                  </button>
                ) : null}
                <button
                  onClick={this.handleClose}
                  style={{
                    padding: '10px 20px',
                    border: '1px solid #6c757d',
                    borderRadius: '4px',
                    backgroundColor: gtype === 3 ? '#6c757d' : '#dc3545',
                    color: 'white',
                    cursor: 'pointer',
                    outline: 'none',
                    transition: 'background-color 0.2s',
                  }}
                >
                  {gtype === 3 ? 'No' : 'Close'}
                </button>
              </div>
            </>
          )}
        </Modal>
      </div>
    );
  }
}

GroupsListAll.propTypes = {
  classes: PropTypes.object.isRequired,
};

const GroupsListStyled = withStyles(styles)(GroupsListAll);

const mapStateToProps = state => ({
  userdata: state.userDialog.userDetails[0],
  unseengroupnotifications: state.userdata.unseengroupnotifications,
});

const mapDispatchToProps = dispatch => ({
  showToast: params => dispatch(showToast(params)),
  fetchUserData: params => dispatch(fetchUserData(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupsListStyled);